export default __webpack_public_path__ + "static/media/PhramacyApp.a3d538dd.svg";